import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./UserTrainingPage.scss";
import bannerUserTraining from "../../assets/images/banner-user-training.png";
import Copyright from "../../components/Copyright/Copyright";

const UserTrainingPage = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="feature-page">
      {/* Hero Section */}
      <section className="feature-hero">
        <div className="container">
          <div className="feature-hero-image">
            <img src={bannerUserTraining} alt="User Training" />
          </div>
        </div>
      </section>

      {/* User Training Information */}
      <section className="feature-info">
        <div className="container">
          <div className="feature-grid">
            <div className="feature-details">
              <h2>User training services</h2>
              <p>
                Empower your team with comprehensive training programs designed to maximize
                your CashManager investment. Our expert trainers ensure your staff can
                effectively utilize all features and optimize their workflow.
              </p>

              <div className="feature-methods">
                <div className="feature-method">
                  <div className="method-content">
                    <h3>On-site training</h3>
                    <p>
                      Personalized training sessions at your location with hands-on practice
                      using your actual data and workflows.
                    </p>
                  </div>
                </div>

                <div className="feature-method">
                  <div className="method-content">
                    <h3>Remote training</h3>
                    <p>
                      Flexible online training sessions that fit your schedule with interactive
                      demonstrations and real-time support.
                    </p>
                  </div>
                </div>

                {/* <div className="training-method">
                  <div className="method-content">
                    <h3>Self-paced learning</h3>
                    <p>
                      Comprehensive video tutorials, documentation, and interactive guides
                      for independent learning at your own pace.
                    </p>
                  </div>
                </div> */}
              </div>
            </div>

            <div className="feature-features">
              <h2>Key features</h2>
              <div className="features-list">
                {/* <div className="feature-item">
                  <h3>Role-based training</h3>
                  <p>Customized training programs tailored to specific user roles and responsibilities.</p>
                </div> */}

                <div className="feature-item">
                  <h3>Hands-on practice</h3>
                  <p>Interactive training sessions with real data and practical exercises.</p>
                </div>

                {/* <div className="feature-item">
                  <h3>Certification programs</h3>
                  <p>Official certification courses to validate user competency and expertise.</p>
                </div> */}

                <div className="feature-item">
                  <h3>Ongoing support</h3>
                  <p>Continuous learning resources and support to keep skills current.</p>
                </div>

                <div className="feature-item">
                  <h3>Multi-language support</h3>
                  <p>Training materials and sessions available in multiple languages.</p>
                </div>

                <div className="feature-item">
                  <h3>Progress tracking</h3>
                  <p>Monitor learning progress and identify areas for additional training.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Training Programs */}
      {/* <section className="training-programs">
        <div className="container">
          <div className="section-header">
            <h2>Training programs</h2>
            <p>Comprehensive training solutions covering all aspects of CashManager</p>
          </div>

          <div className="programs-grid">
            <div className="program-item">
              <h3>Basic user training</h3>
              <ul>
                <li>System navigation and interface</li>
                <li>Basic data entry and management</li>
                <li>User account setup and permissions</li>
                <li>Basic reporting and queries</li>
                <li>Security best practices</li>
                <li>Help and support resources</li>
              </ul>
            </div>

            <div className="program-item">
              <h3>Advanced user training</h3>
              <ul>
                <li>Complex reporting and analytics</li>
                <li>Advanced data manipulation</li>
                <li>Workflow automation</li>
                <li>Integration management</li>
                <li>Custom configuration</li>
                <li>Performance optimization</li>
              </ul>
            </div>

            <div className="program-item">
              <h3>Administrator training</h3>
              <ul>
                <li>System administration</li>
                <li>User management and security</li>
                <li>Backup and recovery procedures</li>
                <li>System monitoring and maintenance</li>
                <li>Integration setup and management</li>
                <li>Troubleshooting and support</li>
              </ul>
            </div>

            <div className="program-item">
              <h3>Specialized training</h3>
              <ul>
                <li>Bank integration and reconciliation</li>
                <li>Electronic invoicing and compliance</li>
                <li>Multi-company management</li>
                <li>Custom development and APIs</li>
                <li>Data migration and import</li>
                <li>Industry-specific workflows</li>
              </ul>
            </div>
          </div>
        </div>
      </section> */}

      {/* Training Process */}
      <section className="implementation-process">
        <div className="container">
          <div className="section-header">
            <h2>Training process</h2>
            <p>Our structured approach ensures effective learning and skill development</p>
          </div>

          <div className="process-steps">
            <div className="process-step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3>Needs assessment</h3>
                <p>Evaluate your team's current skills and identify specific training requirements.</p>
              </div>
            </div>

            <div className="process-step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3>Training plan development</h3>
                <p>Create a customized training plan based on roles, schedules, and learning objectives.</p>
              </div>
            </div>

            <div className="process-step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3>Training delivery</h3>
                <p>Conduct training sessions using the most appropriate delivery method for your team.</p>
              </div>
            </div>

            <div className="process-step">
              <div className="step-number">4</div>
              {/* <div className="step-content">
                <h3>Assessment & certification</h3>
                <p>Evaluate learning outcomes and provide certification for completed training programs.</p>
              </div>
            </div>

            <div className="process-step">
              <div className="step-number">5</div> */}
              <div className="step-content">
                <h3>Follow-up support</h3>
                <p>Provide ongoing support and additional training as needed to ensure continued success.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to train your team?</h2>
            <p>
              Invest in your team's success with professional CashManager training.
              Contact us today to discuss your training needs.
            </p>
            <Link to="/onboarding" className="btn btn-secondary btn-large">Get started</Link>
          </div>
        </div>
      </section>

      {/* Copyright Section */}
      <Copyright />
    </div>
  );
};

export default UserTrainingPage;
